import React from "react";
import DashboardLayout from "../../layout/dashboardLayout";
import Callbettable from "./callbettable";

const CallBet = () => {
    return (
        <DashboardLayout>
            <Callbettable />
        </DashboardLayout>
    )
};

export default CallBet;
